import React from 'react';
import './footer.css'




function Footer() {
  return (
    <div className='footer'>
        <div className='footer-content'>

            <div className='footer-icon-links-container'>
                
                    
            </div>

           


         </div>

         <div className='footer-copyright'>
                <p className='footer-copyright-message'>
              Mood Board demo Sara Donaldson April 2023</p>
        </div>



    </div>
  )
}

export default Footer